import {createApp} from 'vue'

import FormHelperAccordion from './components/FormHelperAccordion.vue'
import FormHelper from './components/FormHelper.vue'
import FormElement from './components/FormElement.vue';
import FormElementDate from './components/FormElementDate.vue';
import FormElementPhone from './components/FormElementPhone.vue';
import FormElementMultiUploader from './components/FormElementMultiUploader.vue';
import FormElementUploadCropper from './components/FormElementUploadCropper.vue';
import FormElementLocation from './components/FormElementLocation.vue';
import FormElementLocationItaly from './components/FormElementLocationItaly.vue';
import FormElementCF from './components/FormElementCF.vue';
import FormElementPIVA from './components/FormElementPIVA.vue';
import FormElementStrongPassword from './components/FormElementStrongPassword.vue';
import FormElementMultiDatePicker from './components/FormElementMultiDatePicker.vue';
import FormElementDatetimePicker from './components/FormElementDatetimePicker.vue';
import FormElementSelectMultiple from './components/FormElementSelectMultiple.vue';
import FormElementCourseMultiDate from './components/FormElementCourseMultiDate.vue';
import FormElementRepeater from './components/FormElementRepeater.vue';
import FormElementCkeditor from './components/FormElementCkeditor.vue';

const components = {
  'form-helper': FormHelper,
  'form-helper-accordion': FormHelperAccordion,
  'form-element': FormElement,
  'form-element-date': FormElementDate,
  'form-element-phone': FormElementPhone,
  'form-element-multiuploader': FormElementMultiUploader,
  'form-element-ckeditor': FormElementCkeditor,
  'form-element-upload-cropper': FormElementUploadCropper,
  'form-element-location': FormElementLocation,
  'form-element-location-italy': FormElementLocationItaly,
  'form-element-cf': FormElementCF,
  'form-element-piva': FormElementPIVA,
  'form-element-strong-password': FormElementStrongPassword,
  'form-element-multi-date-picker': FormElementMultiDatePicker,
  'form-element-datetime-picker': FormElementDatetimePicker,
  'form-element-select-multiple': FormElementSelectMultiple,
  'form-element-course-multi-date': FormElementCourseMultiDate,
  'form-element-repeater': FormElementRepeater,
}

var testData = jQuery("#app").data('fields');
jQuery("#app").removeAttr('data-fields');
var formHelperType = jQuery('.main-content').data('fhtype');
if(formHelperType == 'accordion'){
  createApp({
    el: "#form-helper-accordion",
    components: components,
    data: function(){
      return {
        data: testData
      }
    }
  });
}else if(formHelperType == 'classic'){
  createApp({
    //el: "#app",
    components: components,
    data: function(){
      return {
        data: testData,
        translations: window.translations,
      }
    },
    template: '<form-helper :success="\'#\'" :data="data" :translations="translations" tooltip-position="left" :show-icons-in-inputs="false"></form-helper>'
  }).mount("#app");
}

jQuery(document).ready(function() {
  jQuery("body").on("click", ".fh-tooltip", function() {
    var toOpen = jQuery(this).parents('.row').find('.fh-tooltip-body');
    toOpen.toggleClass('open');
  });
})

